import firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/auth'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDCQUhcvXxWfAIaFmb2z9Ii5LKQGhCsQEc",
  authDomain: "sgnl-cln.firebaseapp.com",
  projectId: "sgnl-cln",
  storageBucket: "sgnl-cln.appspot.com",
  messagingSenderId: "470692256283",
  appId: "1:470692256283:web:316965ab6afe126fa0f6be",
  measurementId: "G-XF5MLWVH0B"
};

let app

if (firebase.apps.length === 0) {
  app = firebase.initializeApp(firebaseConfig)  
} else {
  app = firebase.app()
}

const db = app.firestore()
const auth = firebase.auth()

export { db, auth }